import { PrimeIcons } from "@primevue/core/api";
import { ApiService } from "./api.service";
import moment from "moment";
export default class EmailSignatureService extends ApiService {
  namespace = "email-signature";
  icon = "Signature";
  name = "Type";
  favicon = "Signature";
  template = "defaultTemplate";
  relations = "";
  singular = this.terminology.emailSignature.singular;
  plural = this.terminology.emailSignature.plural;
  vowel = this.terminology.emailSignature.vowel;
  name = `${this.vowel} ${this.singular}`;
  Width = 900;
  DOMAIN = -21;
  action = "actionPreview";
  navItems = [
    {
      key: "active",
      label: this.t("viewActiveEntity", { entity: this.plural }),
      services: 18,
      icon: "Enabled",
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: "Disable",
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: "Bullets",
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: "Bookmark",
    },
  ];
  gemItems = [
    {
      key: "create",
      label: this.t("addAEntity", { entity: this.singular }),
      icon: PrimeIcons.PLUS_CIRCLE,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: PrimeIcons.LIST,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: "Tag",
      field: "display_name",
    },
    {
      header: this.t("subject"),
      icon: "Tag",
      field: "subject",
    },

    {
      header: this.t("date"),
      icon: "GreenCalendar",
      field: "date",
      template: (data) => {
        return moment.unix(data.created_at).format("MM/DD/YYYY");
      },
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an " + this.name,
      icon: PrimeIcons.PLUS,
    },
  ];
  // filterItems = [];
  getActionMenu(item) {
    let listMenuItems = [
      {
        key: "edit",
        label: "Edit an Employee",
        icon: "edit",
      },
      {
        key: "status",
        label: 1 == item.status ? "inactiveThisEntity" : "activeThisEntity",
        icon: 1 == item.status ? "Disable" : "Enabled",
      },
    ];
    return listMenuItems;
  }
  constructor() {
    super("email-signatures");
  }
}
